import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async obtener(payload = {}) {
    const response = await api.post(API_URL + "tipster-landing/obtener", payload);
    return response.data;
  },

  async crear(payload) {
    const response = await api.post(API_URL + "tipster-landing/crear", payload);
    return response.data;
  },

  async guardar(payload) {
    const response = await api.post(API_URL + "tipster-landing/guardar", payload);
    return response.data;
  },

  async borrar(id) {
    const response = await api.post(API_URL + "tipster-landing/borrar", { id });
    return response.data;
  },

  async uploadImagen(tipsterId, file) {
    const formData = new FormData();
    formData.append("tipster_id", tipsterId);
    formData.append("imagen", file);
    const response = await api.post(API_URL + "tipster-landing/upload-imagen", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
};
